import { AsciiText } from '../framework/AsciiText';
export class SonyBraviaRs232 {
    constructor(socket, log) {
        this.socket = socket;
        this.videoInput = 0x401; // HDMI 1
        this.power = false;
        this.asyncHandlers = [
            {
                name: 'powerQuery',
                regExp: /^\x83\x00\x00\xff\xff[\s\S]/,
                callback: (match) => {
                    this.socket.send(this.makeCommand([0x70, 0x00, 0x02, this.power ? 1 : 0]));
                },
            },
            {
                name: 'powerSet',
                regExp: /^\x8c\x00\x00\x02([\s\S])[\s\S]/,
                callback: (match) => {
                    this.power = match[1].charCodeAt(0) === 1;
                    this.socket.send(this.makeCommand([0x70, 0x00]));
                },
            },
            {
                name: 'videoInputQuery',
                regExp: /^\x83\x00\x02\xff\xff[\s\S]/,
                callback: (match) => {
                    const srcHi = this.videoInput >> 8;
                    const srcLo = this.videoInput & 0x00ff;
                    this.socket.send(this.makeCommand([0x70, 0x00, 0x03, srcHi, srcLo]));
                },
            },
            {
                name: 'videoInputSet',
                regExp: /^\x8c\x00\x02\x03([\s\S]{2})[\s\S]/,
                callback: (match) => {
                    const srcHi = match[1].charCodeAt(0);
                    const srcLo = match[1].charCodeAt(1);
                    this.videoInput = (srcHi << 8) + srcLo;
                    this.socket.send(this.makeCommand([0x70, 0x00]));
                },
            },
            {
                name: 'volumeSet',
                regExp: /^\x8c\x00\x05\x03\x01([\s\S])[\s\S]/,
                callback: (match) => {
                    // There is no volume query, so don't store the volume.
                    this.socket.send(this.makeCommand([0x70, 0x00]));
                },
            },
            {
                name: 'volumeMuteSet',
                regExp: /^\x8c\x00\x06\x03\x01([\s\S])[\s\S]/,
                callback: (match) => {
                    // There is no volume mute query, so don't store the volume mute.
                    this.socket.send(this.makeCommand([0x70, 0x00]));
                },
            },
            {
                regExp: /.+/,
                callback: (match) => {
                    // No response to invalid commands.
                },
            },
        ];
    }
    onConfigure(config) {
        var _a;
        let lowestCode;
        for (const videoInput of Object.values((_a = config.videoInputs) !== null && _a !== void 0 ? _a : {})) {
            const code = parseInt(videoInput.code, 16);
            if (this.videoInput === code)
                return;
            if (lowestCode === undefined || code < lowestCode) {
                lowestCode = code;
            }
        }
        this.videoInput = lowestCode !== null && lowestCode !== void 0 ? lowestCode : 0x401;
    }
    commandExtractor(buffer) {
        for (let i = 0; i < buffer.length - 2; i++) {
            if (buffer.charCodeAt(i) === 0x8c || buffer.charCodeAt(i) === 0x83) {
                let checksum = buffer.charCodeAt(i);
                let j = 1;
                // command  is 0x83 or 0x8c, 00, numBytes, byte1, ..., byteN,  checksum
                while (j < buffer.length - 1) {
                    checksum += buffer.charCodeAt(i + j);
                    checksum &= 0x00ff;
                    // commands will always be at least 5 bytes long plus a checksum
                    if (j >= 4 && checksum === buffer.charCodeAt(i + j + 1)) {
                        const command = buffer.slice(i, i + j + 2); // include the checksum
                        buffer = buffer.slice(i + j + 2);
                        return { command, buffer };
                    }
                    j++;
                }
            }
        }
        return undefined;
    }
    makeCommand(data) {
        const bytes = [...data];
        const checksum = bytes.reduce((sum, p) => sum + p);
        bytes.push(checksum & 0x00ff);
        return AsciiText.decode(bytes);
    }
}
SonyBraviaRs232.emulatorType = 'socketEmulator';
SonyBraviaRs232.key = '-NT9I4XhJiOMgpfMxw9V';
